export const AI_IMAGE_NOTICE = 'AI-generated media. Read the description for accurate form.';

export const getAiImageNotice = (t) => (
  t?.('questDetails.aiGeneratedNotice', AI_IMAGE_NOTICE) || AI_IMAGE_NOTICE
);

export const buildQuestImageReportKey = ({ scope, exerciseIndex, imageUrl, mediaUrl, mediaType = 'image' } = {}) => [
  scope || '',
  mediaType || 'image',
  Number.isInteger(exerciseIndex) ? exerciseIndex : 'meal',
  mediaUrl || imageUrl || ''
].join(':');
